import axios from 'axios'

const instance = axios.create({
	baseURL: 'https://rixadev-be-94oxa.ondigitalocean.app/api', // digital ocean
})

export default instance
